<template>
  <div id="template">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        ref="queryForm"
        :model="queryParams"
        label-width="119px"
        style="padding: 0 5px"
      >
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="物流方式代码：">
                <el-input
                  size="small"
                  v-model="queryParams.expreModeCode"
                  placeholder="请输入物流方式代码"
                  clearable
                />
              </el-form-item></div
          ></el-col>

          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="物流方式名称：">
                <el-input
                  size="small"
                  v-model="queryParams.expreModeName"
                  placeholder="请输入物流方式名称"
                  clearable
                />
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24"
            ><div class="grid-content bg-purple">
              <div style="text-align: right; margin: auto; padding-top: 10px">
                <el-button size="small" type="primary" @click="getList"
                  >搜索</el-button
                >
                <el-button size="small" @click="resetForm">重置</el-button>
              </div>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>
    <div class="form-body">
      <div class="form-body-header">
        <div class="left" style="margin: 0 16px 0 0">
          <el-button type="primary" size="small" @click="handleAddExpress"
            >新增</el-button
          >
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <el-table
        id="outTable"
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="expreModeCode"
          label="物流方式代码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="expreModeName"
          label="物流方式名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="firstPrice"
          label="首重价格"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="firstWeight"
          label="首重重量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="contPrice"
          label="续重价格"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="contWeight"
          label="续重重量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="operCost"
          label="操作费"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="state"
          label="国家"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="province"
          label="省/州"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="referTime"
          label="参考时限"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="formula"
          label="计算公式"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
        :page-sizes="[10, 20, 50, 100]"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      class="type-edit-dialog"
      :dialogTitle="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="119px"
        :rules="rules"
        style="margin: 15px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="物流方式代码：" prop="expreModeCode">
              <el-input
                size="small"
                v-model="form.expreModeCode"
                placeholder="请输入物流方式代码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流方式名称：" prop="expreModeName">
              <el-input
                size="small"
                v-model="form.expreModeName"
                placeholder="请输入物流方式名称"
                maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首重价格：" prop="firstPrice">
              <el-input
                size="small"
                v-model="form.firstPrice"
                placeholder="请输入首重价格"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首重重量：" prop="firstWeight">
              <el-input
                size="small"
                v-model="form.firstWeight"
                placeholder="请输入首重重量"
                maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="续重价格：" prop="contPrice">
              <el-input
                size="small"
                v-model="form.contPrice"
                placeholder="请输入续重价格"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="续重重量：" prop="contWeight">
              <el-input
                size="small"
                v-model="form.contWeight"
                placeholder="请输入续重重量"
                maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作费：" prop="operCost">
              <el-input
                size="small"
                v-model="form.operCost"
                placeholder="请输入操作费"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国家：" prop="state">
              <el-select
                clearable
                v-model="form.state"
                placeholder="请选择国家"
                class="input"
                size="small"
                @change="handleChangeState"
              >
                <el-option
                  v-for="(value, index) in dictData['amazon_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省/州：" prop="province">
              <el-select
                v-if="form.state == 'CN'"
                clearable
                value-key="code"
                size="small"
                v-model="form.province"
                placeholder="省"
                @change="provinceChange"
              >
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                v-else
                v-model="form.province"
                class="input"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考时限：" prop="referTime">
              <el-input
                size="small"
                v-model="form.referTime"
                placeholder="请输入参考时限"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="计算公式：" prop="formula">
              <el-input
                size="small"
                v-model="form.formula"
                placeholder="请输入计算公式"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from "@/components/common/Breadcrumb";
import { listExpress, addExpress, deleteExpress  } from "@/api/order/express";
import { mapGetters } from "vuex";
import dayjs from "dayjs"

export default {
  name: "codeManage",
  components: { Breadcrumb },
  data() {
    return {
      selectValue1: "",
      total: 0,
      currentPage: 1,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        expreModeCode: '',
        expreModeName: '',
      },
      form: {
        "expreModeCode": "",
        "expreModeName": "",
        "firstPrice": '',
        "firstWeight":'',
        "contPrice": '',
        "contWeight": '',
        "operCost":'',
        "state": "",
        "province": "",
        "referTime": "",
        "formula": "",
      },
      operateTime: [],
      dateValue: [],
      tableData: [],
      eanVisible: false,
      upcVisible: false,
      rules: {
        expreModeCode: [{required: true, message: '请输入物流方式代码', trigger: 'change'}],
        expreModeName: [{required: true, message: '请输入物流方式名称', trigger: 'change'}],
        firstPrice: [{required: true, message: '请输入首重价格', trigger: 'change'}],
        firstWeight: [{required: true, message: '请输入首重重量', trigger: 'change'}],
        contPrice: [{required: true, message: '请输入续重价格', trigger: 'change'}],
        contWeight: [{required: true, message: '请输入续重重量', trigger: 'change'}],
      },
      maxNum: 0,
      detailVisible: false,
      codeData: [],
      fileList1: [],
      dialogVisible: false,
      dialogTitle: '',
      provinceOptions: [],
    };
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
  },
  created() {
    this.getList();
    this.loadProvData()
  },
  methods: {
     loadProvData() {
      $.ajax({
        url: process.env.BASE_URL + "areaData.json",
        method: "get",
        success: (res) => {
          this.provinceOptions = res["regionalDivision"]
          this.provinceChange({ name: this.form.province })
        },
      })
    },
     provinceChange(val) {
      this.form.province = val.name
    },
    getList(){
       let params = Object.assign({}, this.queryParams)
       if (this.operateTime && this.operateTime.length > 0) {
        params["beginTime"] = dayjs(this.operateTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.operateTime[1]).format("YYYY-MM-DD")
      }
      listExpress(params).then((result)=>{
        this.tableData = result.rows
        this.total = result.total
      })
    },
    cancel() {
      this.dialogVisible = false
      this.reset()
    },
     reset() {
      this.form = {
        "expreModeCode": "",
        "expreModeName": "",
        "firstPrice": '',
        "firstWeight":'',
        "contPrice": '',
        "contWeight": '',
        "operCost":'',
        "state": "",
        "province": "",
        "referTime": "",
        "formula": "",
      }
    },
    handleUpdate(row){
      this.form = this._.clone(row)
      this.dialogVisible = true
    },
    resetForm(){
       this.queryParams = Object.assign(this.queryParams,{
        productCodeType: '',
        factoryCode: '',
        isUse: null,
      })

      this.operateTime = []
    },
    handleAddExpress(){
      this.dialogTitle = '新增'
      this.dialogVisible = true
       this.form = {
        "expreModeCode": "",
        "expreModeName": "",
        "firstPrice": '',
        "firstWeight":'',
        "contPrice": '',
        "contWeight": '',
        "operCost":'',
        "state": "",
        "province": "",
        "referTime": "",
        "formula": "",
      }
      this.$refs['form'].clearValidate()
    },
      handleDelete(row) {
      this.$confirm("确定要删除【" + row.expreModeName + "】吗？", "警告", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(async () => {
          await deleteExpress(row.expreConfId)
          this.getList()
          this.$message.success("删除成功")
        })
        .catch((err) => {})
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
            addExpress(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("保存成功")
                this.dialogVisible = false
                this.getList()
              }
            })
        }
      })
    },
    handleChangeState(){
        this.form.province = ''
    }
  },
  mounted() {},
};
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.form-content {
  background: #ffffff;
}
</style>
